import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';
import { WORKSPACE_FRAGMENT } from './schema';
import { FRAGMENT_BRAND_VOICE } from '../brandVoices/schema';
import { FRAGMENT_CUSTOMER_RESOURCE, FRAGMENT_INTEGRATION_ACCOUNT } from '../performance/schema';
import { FRAGMENT_FREESTYLE_TOOL } from '../freestyleTools/schema';
import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from '../customerMultiPromptTemplates/schema';
import { FRAGMENT_TALKING_POINTS_VIEW } from '../talkingPointsViews/schema';

const QUERY = gql`
  query Workspace($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          ...Workspace
          associatedBrandVoices {
            ...BrandVoice
          }
          associatedAccounts {
            ...PerformanceCenterIntegrationAccount
          }
          associatedFreestyleTools {
            ...SuggestionFreestyleTool
          }
          associatedMultiPromptTemplates {
            ...CustomerMultiPromptTemplate
          }
          associatedResources {
            ...PerformanceCenterCustomerResource
          }
          associatedTalkingPointsViews {
            ...TalkingPointsView
          }
          defaultBrandVoice {
            ...BrandVoice
          }
        }
      }
    }
  }
  ${WORKSPACE_FRAGMENT}
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_INTEGRATION_ACCOUNT}
  ${FRAGMENT_FREESTYLE_TOOL}
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
  ${FRAGMENT_CUSTOMER_RESOURCE}
  ${FRAGMENT_TALKING_POINTS_VIEW}
`;

export const queryWorkspace = (variables) => {
  return executeGqlQuery({
    query: QUERY,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
